import { render, staticRenderFns } from "./DividerComp.vue?vue&type=template&id=9981b0a4"
import script from "./DividerComp.vue?vue&type=script&lang=js"
export * from "./DividerComp.vue?vue&type=script&lang=js"
import style0 from "./DividerComp.vue?vue&type=style&index=0&id=9981b0a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports